// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2076) return "static/chunks/72fc93ab-78e31f1b18443b89.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "bc2b4d1d04e94235" + ".js";
};